module.exports = __webpack_public_path__ + "static/img/9.28ad905.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/zh/9.png
// module id = wlOn
// module chunks = 0